<template>
  <div>
    <div ref="headerSlot">
      <slot name="header" />
    </div>
    <div
      ref="contentRef"
      :style="{ height, overflow, maxHeight, minHeight }"
      class="fill-area fill-width"
      :class="[contentClass, { 'message-dialog-content': messageDialogContent }]"
    >
      <slot />
    </div>
  </div>
</template>

<script>
import { isIos, isBrave } from "@/services/environment.js"

import { DESKTOP_TOP_BAR_HEIGHT, MOBILE_TOP_BAR_HEIGHT } from "@/constants/barHeights.js"

export default {
  props: {
    offset: {
      type: Number,
      default: 0
    },
    overflow: {
      type: String,
      default: "auto"
    },
    useMaxHeight: {
      type: Boolean,
      default: false
    },
    useMinHeight: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    messageDialogContent: {
      type: Boolean,
      default: false
    },
    contentClass: {
      type: String,
      default: ""
    },
    ignoreHeaderSize: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      height: "auto",
      maxHeight: "none",
      minHeight: "none",
      isIosOrBrave: isIos() || isBrave()
    }
  },
  watch: {
    disabled() {
      this.updateStyle()
    },
    offset() {
      this.updateStyle()
    }
  },
  activated() {
    this.updateStyle()
  },
  mounted() {
    this.updateStyle()
    this.$eventBus.$on("window-resize", this.updateStyle)
    this.$eventBus.$on("viewport-resize", this.updateStyle)
  },
  beforeUnmount() {
    this.$eventBus.$off("window-resize", this.updateStyle)
    this.$eventBus.$off("viewport-resize", this.updateStyle)
  },
  methods: {
    updateStyle() {
      this.height = "auto"
      this.maxHeight = "none"
      if (this.disabled) {
        return
      }

      //For android devices document.documentElement.clientHeight doesn't change
      //when browser's address bar is sliding down/up
      //For iOS devices window.innerHeight doesn't include keyboard height
      const windowHeight = (this.isIosOrBrave && window.visualViewport?.height) || window.innerHeight

      const top = this.ignoreHeaderSize ? 0 : this.$vuetify.display.mobile ? MOBILE_TOP_BAR_HEIGHT : DESKTOP_TOP_BAR_HEIGHT

      let headerElementHeight = 0

      if (this.$slots?.header && this.$refs.headerSlot) {
        headerElementHeight = this.$refs.headerSlot.getBoundingClientRect().height
      }

      const height = `${windowHeight - this.offset - top - headerElementHeight}px`

      if (this.useMaxHeight) {
        this.maxHeight = height
      }

      if (this.useMinHeight) {
        this.minHeight = `${windowHeight - this.offset - top}px`
      }

      if (!this.useMaxHeight && !this.useMinHeight) {
        this.height = height
      }
    },
    getContentRef() {
      return this.$refs.contentRef
    }
  }
}
</script>
